<template>
  <div>
    <div class="sayfahead m-0">
      <h1><small>SGK Entegrasyon
        <sup :class="Kurulum?'text-success':'text-danger'">
            <b>{{ this.$store.getters.SubDomain }}-{{ Bina_id }}</b>
        </sup>
      </small>

      </h1>
      <el-button-group class="float-right">

      </el-button-group>
    </div>

    <div class="TanitimBlok">
      <br>
      <h4>SGK Entegrasyonu</h4>
      <h5>Uzman Mali Müşavir Ekibimiz ile Entegre olun</h5>
      <h6>Bütün SGK Bordro işlemlerinizi uzman ekibimiz ile günceli ve hızlı bir şekilde çözümlüyoruz.</h6>
      <a target="_blank" class="btn btn-yesil"
         :href="'https://api.whatsapp.com/send?phone=908508403806&text=Merhaba, '+BinaKodu+' Kodlu binamın SGK Entegrasyonunu aktif etmenizi istiyorum.'">
        Şimdi Whatsapp ile Entegre Ol
      </a>
    </div>
  </div>

</template>

<script>
export default {
  props: ['Bina_id'],
  data() {
    return {
      Kurulum: false
    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaSgk.vue